import FooterListItem from "./FooterListItem"
import { Link } from "react-router-dom"
import React from "react"

const InternalLink = (content, icon, lang, proxyPath) => {
    const { id, alternateLink } = content

    return (
        <Link
            key={id}
            style={{ textDecoration: "none", color: "#000" }}
            to={alternateLink
                ? `${proxyPath}/${lang}/${alternateLink}`
                : `${proxyPath}/${lang}/static/${id}`}
        >
            {FooterListItem(content, icon, lang)}
        </Link>
    )
}

export default InternalLink
